module.exports = __webpack_public_path__ + "static/media/Win-WinWhitelabelAppSolution.1e46661e.png";